<ui-badge
  class="wishlist-status-pill"
  [class.wishlist-status-pill-compact]="compact()"
  [tone]="badgeTone()"
  [attr.aria-label]="accessibleLabel()"
  [attr.title]="label()"
>
  @if (hasIcon()) {
    <span class="wishlist-status-pill__icon" aria-hidden="true">{{
      iconLabel()
    }}</span>
  }
  <span class="wishlist-status-pill__label">{{ label() }}</span>
</ui-badge>
